import { render, staticRenderFns } from "./kartu_barang.vue?vue&type=template&id=e2b5672c&"
import script from "./kartu_barang.vue?vue&type=script&lang=js&"
export * from "./kartu_barang.vue?vue&type=script&lang=js&"
import style0 from "./kartu_barang.vue?vue&type=style&index=0&id=e2b5672c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports